var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.98,20.86l6.08,6.08l-2.12,2.12l-6.08-6.08c-2.03,1.58-4.59,2.52-7.36,2.52c-6.63,0-12-5.37-12-12s5.37-12,12-12 s12,5.37,12,12C25.5,16.27,24.56,18.83,22.98,20.86z M13.5,22.5c4.97,0,9-4.03,9-9s-4.03-9-9-9s-9,4.03-9,9S8.53,22.5,13.5,22.5z"
  })));
};
export default SvgSearch;